import dev from '../images/projects/dev.png';
import pizza from '../images/projects/pizza.png';
import resume from '../images/projects/resume.png';
import chat from '../images/projects/chat.png';
import travel from '../images/projects/travel.png';
import expense from '../images/projects/expense.png';
import news from '../images/projects/news.png';
import covid from '../images/projects/covid.png';
import movie from '../images/projects/movie.png';
import notes from '../images/projects/notes.png';
import todo from '../images/projects/todo.png';
import crypto from '../images/projects/crypto.png';
import shades from '../images/projects/shades.png';
import dummy from '../images/projects/dummy.png';
import finder from '../images/projects/finder.png';
import urlshort from '../images/projects/urlshort.png';
import exercise from '../images/projects/exercise.png';
import kbc from '../images/projects/kbc.png';
import dictionary from '../images/projects/dictionary.png';
import weather from '../images/projects/weather.png';

const projects = [
  
    {
        id: 1,
        category: 'MERN',
        link1: 'https://github.com/anuragtomar2510/dev-connect',
        link2: `https://anuragtomar2510-dev-connect.netlify.app/`,
        image: dev,
        title: `Dev-Connect`
    },

    {
        id: 2,
        category: 'MERN',
        link1: 'https://github.com/anuragtomar2510/realtime-pizza-order-tracking-application',
        link2: `https://github.com/anuragtomar2510/realtime-pizza-order-tracking-application`,
        image: pizza,
        title: `Realtime Pizza Order Tracking App`
    },

    {
        id: 3,
        category: 'MERN',
        link1: 'https://github.com/anuragtomar2510/resume-builder-app',
        link2: `https://main.d2vmd2mjm9f0i8.amplifyapp.com/`,
        image: resume,
        title: `Resume Builder`
    },

    {
        id: 4,
        category: 'MERN',
        link1: 'https://github.com/anuragtomar2510/realtime-chat-app',
        link2: `https://anuragtomar2510-chat-app.netlify.app/`,
        image: chat,
        title: `Realtime Chat App`
    },


    {
        id: 5,
        category: 'MERN',
        link1: 'https://github.com/anuragtomar2510/travel-log-app',
        link2: `https://anuragtomar2510-travel-log-app.herokuapp.com/`,
        image: travel,
        title: `Travel-log App`
    },


    {
        id: 6,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/expense-tracker',
        link2: `https://anuragtomar2510-expense-tracker.netlify.app/`,
        image: expense,
        title: `Expense Tracker`
    },

    {
        id: 7,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/notes-app',
        link2: `https://anuragtomar2510-notes-app.netlify.app/`,
        image: notes,
        title: 'Note-taking App'
    },

    {
        id: 8,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/news-app',
        link2: `https://github.com/anuragtomar2510/news-app`,
        image: news,
        title: `News App`
    },

    {
        id: 9,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/covid19-tracker',
        link2: `https://anuragtomar2510-covid19-tracker.netlify.app/`,
        image: covid,
        title: `Covid-19 Tracker`
    },

    {
        id: 10,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/movie-info-app',
        link2: `https://anuragtomar2510-movie-info-app.netlify.app/`,
        image: movie,
        title: 'Movie-info App'
    },

   

    {
        id: 11,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/todo-list-app',
        link2: 'https://anuragtomar2510-todo-app.netlify.app/',
        image: todo,
        title: 'To-do list App'
    },

    {
        id: 12,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/Cryptocurrency-Price-Tracker',
        link2: 'https://anuragtomar2510-cryptocurrency-price-tracker.netlify.app/',
        image: crypto,
        title: 'Cryptocurrency Price Tracker'
    },

    {
        id: 13,
        category: 'MERN',
        link1: 'https://github.com/anuragtomar2510/url-shortener',
        link2: 'https://anuragtomar2510-url-shortener.herokuapp.com/',
        image: urlshort,
        title: 'URL Shortener'
    },

    
    {
        id: 14,
        category: 'MERN',
        link1: 'https://github.com/anuragtomar2510/exercise-tracker',
        link2: 'https://anuragtomar2510-exercise-app.herokuapp.com/',
        image: exercise,
        title: 'Exercise Tracker'
    },

    {
        id: 15,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/image-finder',
        link2: 'https://anuragtomar2510-image-finder.netlify.app/',
        image: finder,
        title: 'Image-finder App'
    },
    
    {
        id: 16,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/color-shades-generator',
        link2: 'https://anuragtomar2510-color-shades-generator.netlify.app/',
        image: shades,
        title: 'Color Shades Generator'
    },

    

    {
        id: 17,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/dummy-text-generator',
        link2: 'https://anuragtomar2510-dummy-text-generator.netlify.app/',
        image: dummy,
        title: 'Dummy Text Generator'
    },   

    {
        id: 18,
        category: 'JavaScript',
        link1: 'https://github.com/anuragtomar2510/Dictionary-App',
        link2: 'https://anuragtomar2510.github.io/Dictionary-App/',
        image: dictionary,
        title: 'Dictionary App'
    },

    {
        id: 19,
        category: 'JavaScript',
        link1: 'https://github.com/anuragtomar2510/Weather-App',
        link2: 'https://anuragtomar2510.github.io/Weather-App/',
        image: weather,
        title: 'Weather App'
    },

    {
        id: 20,
        category: 'React Js',
        link1: 'https://github.com/anuragtomar2510/kbc-app',
        link2: 'https://anuragtomar2510-kbc-app.netlify.app/',
        image: kbc,
        title: 'KBC App'
    }


  
]

export default projects;